import React from "react";

const getMatches = (query: string) => (typeof window === "undefined" ? false : window.matchMedia(query).matches);

export default function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(() => getMatches(query));

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}

export const useAdminPanelNarrowLayout = () => useMediaQuery("(max-width: 768px)");

export const useWorkspaceCompactHeader = () => useMediaQuery("(max-width: 1199px)");
